import React from 'react';
import {ErrorBoundary as SentryErrorBoundary} from '@sentry/react';
import {UpdateMessage} from './Messages/UpdateMessage.js';
import {ErrBoundaryError} from './ErrBoundaryError.js';

export const ErrorBoundary = ({refresh, ...props}) => {

    const handleFallback = ({error, padded}) => {
        switch (error.name) {
            case 'ChunkLoadError' :
                return <UpdateMessage/>;
            default :
                return <ErrBoundaryError padded={padded} refresh={refresh}/>;
        }
    };

    return <SentryErrorBoundary fallback={handleFallback} {...props} />;
};